import ActivePatients from './ActivePatients';

export default ActivePatients;
